import { Injectable } from '@angular/core';
import * as _ from 'lodash';

export interface Language {
    value: string;
    displayName: string;
}

@Injectable()
export class LanguageService {

    private _languages: Language[] = [
        {value: 'en', displayName: 'Anglais'},
        {value: 'fr', displayName: 'Français'},
    ];

    get languages(): Language[] {
        return this._languages;
    }

    public language(value: string): Language {
        return _.find(this._languages, {value} );
    }

    public displayName(value: string): string {
        const language = this.language(value);
        return language ? language.displayName : 'langue inconnue';
    }
}
